import { CSSProperties, useState } from "react";
import styles from "../CreatorsPage.module.scss";

const PER_TRAVELLER = 0.5;
const GUIDE_PRICE = 12.99;
const GUIDE_SHARE = 0.8;

const euros = (amount: number) => `€${Math.round(amount).toLocaleString("en-GB")}`;
/** How far a slider is along its track, for the green fill (`--p` in the stylesheet). */
const fill = (value: number, max: number): CSSProperties => ({ "--p": `${(value / max) * 100}%` }) as CSSProperties;

/** "An example month": two sliders and what they would earn. An example, labelled as one, not real data. */
const Calculator = () => {
	const [travellers, setTravellers] = useState(600);
	const [guides, setGuides] = useState(60);
	const fromTravellers = travellers * PER_TRAVELLER;
	const fromGuides = guides * GUIDE_PRICE * GUIDE_SHARE;
	const travellersLabel = travellers.toLocaleString("en-GB");

	return (
		<form className={styles.calc} aria-labelledby="calc-h" onSubmit={(e) => e.preventDefault()}>
			<h3 id="calc-h">An example month</h3>
			<label htmlFor="c1">
				<span>
					Active travellers through you <output>{travellersLabel}</output>
				</span>
				<input
					id="c1"
					type="range"
					min="0"
					max="3000"
					step="50"
					value={travellers}
					style={fill(travellers, 3000)}
					onChange={(e) => setTravellers(+e.target.value)}
				/>
			</label>
			<label htmlFor="c2">
				<span>
					Guides sold <output>{guides}</output>
				</span>
				<input id="c2" type="range" min="0" max="300" step="5" value={guides} style={fill(guides, 300)} onChange={(e) => setGuides(+e.target.value)} />
			</label>
			<div className={styles.total}>
				<small>You'd earn about</small>
				<b>{euros(fromTravellers + fromGuides)}</b>
				<div className={styles.brk}>
					<div>
						<span>{travellersLabel} travellers × €0.50</span>
						<span>{euros(fromTravellers)}</span>
					</div>
					{guides > 0 && (
						<div>
							<span>{guides} guides × €12.99 × 80%</span>
							<span>{euros(fromGuides)}</span>
						</div>
					)}
				</div>
			</div>
			<p className={styles.fine}>
				An example, not a promise. A traveller counts once they've planned at least one trip. Guides at €12.99, 80% of revenue after payment fees. Your
				affiliate links come on top.
			</p>
		</form>
	);
};

export default Calculator;
